import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, normalizeClass as _normalizeClass, renderList as _renderList, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, createBlock as _createBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = (n: any) => (_pushScopeId("data-v-8b51db6c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "container"
}
const _hoisted_2 = ["innerHTML"]
const _hoisted_3 = {
  key: 0,
  class: "description"
}
const _hoisted_4 = { class: "video" }
const _hoisted_5 = ["src"]
const _hoisted_6 = {
  key: 0,
  class: "images"
}
const _hoisted_7 = ["src", "onClick"]
const _hoisted_8 = ["src"]
const _hoisted_9 = /*#__PURE__*/ _withScopeId(() => /*#__PURE__*/_createElementVNode("img", {
  src: "/images/icon_up.svg",
  class: "mobile-icon"
}, null, -1))
const _hoisted_10 = [
  _hoisted_9
]

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_flicking = _resolveComponent("flicking")!
  const _component_dots_navigation = _resolveComponent("dots-navigation")!
  const _component_image_viewer = _resolveComponent("image-viewer")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    (_ctx.store.loaded)
      ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
          _createElementVNode("div", {
            class: _normalizeClass(['media', {'mobile-media': _ctx.store.showMobile}])
          }, [
            _createElementVNode("div", {
              class: _normalizeClass({'mobile-top-block': _ctx.store.showMobile})
            }, [
              _createElementVNode("h1", {
                innerHTML: _ctx.item?.title
              }, null, 8, _hoisted_2),
              (_ctx.item?.desc?.length)
                ? (_openBlock(), _createElementBlock("div", _hoisted_3, _toDisplayString(_ctx.item?.desc), 1))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_4, [
                (_ctx.isVisible)
                  ? (_openBlock(), _createElementBlock("iframe", {
                      key: 0,
                      src: 'https://rutube.ru/play/embed/' + _ctx.item?.youtubeCode,
                      width: "100%",
                      height: "100%",
                      frameBorder: "0",
                      allow: "clipboard-write; autoplay",
                      webkitAllowFullScreen: "",
                      mozallowfullscreen: "",
                      allowFullScreen: ""
                    }, null, 8, _hoisted_5))
                  : _createCommentVNode("", true)
              ])
            ], 2),
            (_ctx.item && _ctx.item.images?.length && !_ctx.store.showMobile)
              ? (_openBlock(), _createElementBlock("div", _hoisted_6, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.images, (image, index) => {
                    return (_openBlock(), _createElementBlock("img", {
                      key: image,
                      src: '/media/' + image,
                      class: "images-item",
                      onClick: ($event: any) => {
              _ctx.imageFile = '/media/' + image;
              _ctx.activeIndex = index;
              _ctx.numberOfImages = _ctx.item.images.length;
              _ctx.imageViewerVisible = true
            }
                    }, null, 8, _hoisted_7))
                  }), 128))
                ]))
              : _createCommentVNode("", true),
            (_ctx.item && _ctx.item.images?.length && _ctx.store.showMobile)
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createVNode(_component_flicking, {
                    options: {
          horizontal: true,
          circular: true,
          bound: false,
          align: 'center',
          inputType: ['pointer'],
          moveType: 'strict',
          autoResize: true,
          adaptive: true,
          panelsPerView: 1,
          defaultIndex: _ctx.activeIndex
          },
                    onChanged: _cache[0] || (_cache[0] = (e) => { _ctx.activeIndex = e.index })
                  }, {
                    default: _withCtx(() => [
                      (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.item.images, (mobileImage) => {
                        return (_openBlock(), _createElementBlock("div", {
                          key: mobileImage,
                          class: "product_image_container_mobile"
                        }, [
                          _createElementVNode("img", {
                            src: '/media/' + mobileImage,
                            class: "product_image_icon_mobile"
                          }, null, 8, _hoisted_8)
                        ]))
                      }), 128))
                    ]),
                    _: 1
                  }, 8, ["options"]),
                  _createVNode(_component_dots_navigation, {
                    "active-index": _ctx.activeIndex,
                    "number-of-items": _ctx.item.images.length
                  }, null, 8, ["active-index", "number-of-items"])
                ], 64))
              : _createCommentVNode("", true)
          ], 2),
          (_ctx.imageViewerVisible && _ctx.item && !_ctx.store.showMobile)
            ? (_openBlock(), _createBlock(_component_image_viewer, {
                key: 0,
                "show-mobile": _ctx.store.showMobile,
                file: '/media/' + _ctx.item?.images[_ctx.activeIndex],
                "number-of-images": _ctx.numberOfImages,
                "active-index": _ctx.activeIndex,
                onImageViewerClose: _cache[1] || (_cache[1] = ($event: any) => (_ctx.imageViewerVisible = false)),
                onImageViewerPrev: _cache[2] || (_cache[2] = ($event: any) => {if (_ctx.activeIndex > 0) {--_ctx.activeIndex};}),
                onImageViewerNext: _cache[3] || (_cache[3] = ($event: any) => {if (_ctx.activeIndex < _ctx.item?.images.length-1) {++_ctx.activeIndex};})
              }, null, 8, ["show-mobile", "file", "number-of-images", "active-index"]))
            : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true),
    (!_ctx.store.showMobile)
      ? (_openBlock(), _createElementBlock("span", {
          key: 1,
          onClick: _cache[4] || (_cache[4] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "link",
          textContent: '<-- Всё там'
        }))
      : (_openBlock(), _createElementBlock("span", {
          key: 2,
          onClick: _cache[5] || (_cache[5] = 
//@ts-ignore
(...args) => (_ctx.goBack && _ctx.goBack(...args))),
          class: "mobile-link"
        }, _hoisted_10))
  ], 64))
}